import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useLayoutEffect } from 'react';

function useIsOverflowing(ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOverflowing = _useState2[0],
    setIsOverflowing = _useState2[1];
  for (var _len = arguments.length, deps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    deps[_key - 1] = arguments[_key];
  }
  useLayoutEffect(function () {
    var element = ref.current;
    if (element) {
      setIsOverflowing(element.scrollWidth > element.clientWidth || element.clientHeight < element.scrollHeight);
    }
  }, [ref.current].concat(deps)); // eslint-disable-line react-hooks/exhaustive-deps -- we don't know the dependencies ahead of time so we need to spread them like this
  return isOverflowing;
}

export { useIsOverflowing };
